export default __webpack_public_path__ + "static/perfect-pair.dark-f0641731d4bf39be912bb436e0d974aa08f7cc92b111a86f58cc691554c6c209.png";